var TrackerHandler;
(function (TrackerHandler) {
    const $targets = document.querySelectorAll('script[data-tracker]');
    const sleepyTrackers = Object.values(window.sleepyTrackers || {});
    function handleTrackers() {
        return new Promise((resolve) => {
            localforage.getItem('latest-cookie-policy')
                .then((id) => {
                if (id) {
                    localforage.getItem('set-cookies')
                        .then((cookies) => {
                        var _a, _b;
                        cookies = cookies || {};
                        resolve((_a = cookies[id]) === null || _a === void 0 ? void 0 : _a.analitycs);
                        showContent((_b = cookies[id]) === null || _b === void 0 ? void 0 : _b.analitycs);
                    });
                }
            });
        });
    }
    handleTrackers()
        .then((analytics) => {
        showContent(analytics);
    });
    function showContent(analytics) {
        if (analytics) {
            $targets.forEach(($script) => {
                const src = $script.getAttribute('data-src');
                const parentId = $script.getAttribute('data-tracker');
                if (src) {
                    $script.setAttribute('src', src);
                }
                if (parentId) {
                    const $parent = document.querySelector(`[data-tracker-container="${parentId}"]`);
                    if ($parent) {
                        $parent.removeAttribute('data-tracker-container');
                    }
                }
            });
            sleepyTrackers.forEach((tracker) => {
                tracker();
            });
        }
    }
    publish(handleTrackers, 'handleTrackers');
})(TrackerHandler || (TrackerHandler = {}));
